import React from "react";
import { Container } from "../general";
import { ReactComponent as Logo } from "../../assets/logo.svg";

const Footer = () => {
  // const year = new Date().getFullYear();

  return (
    <Container>
      <footer className="flex flex-col items-center justify-center py-6">
        <Logo />
        {/* <p className="text-primary mt-2">&copy; {year}</p> */}
      </footer>
    </Container>
  );
};

export default Footer;
